import axios from "axios";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { findDOMNode } from "react-dom";
import {
  AiOutlineFullscreen,
  AiOutlineAudioMuted,
  AiOutlineAudio,
} from "react-icons/ai";
import { FaBug, FaPause, FaPlay, FaTimesCircle } from "react-icons/fa";
import {
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { connect, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import screenfull from "screenfull";
import InputField from "../components/InputField";
import VideoPlayer from "../components/VideoPlayerOld";
import { SaveMatchString } from "../redux/actions/analysisAction";
import {
  ClearSeekFlag,
  LoadVideoUrl,
  SetControllerToggle,
  SetVideoControl,
  UpdateVideoTime,
} from "../redux/actions/controlAction";

import Logo from "../assets/Logo";
import SimpleButton from "../components/SimpleButton";
import Duration from "../components/VideoPlayer(new)/DurationOld";
import { FaStopwatch } from "react-icons/fa";
import { SSENSE_URL, MAIN_API } from "../config/stepoutAPI";
import { FaArrowRight, FaChevronRight } from "react-icons/fa";
import zIndex from "@mui/material/styles/zIndex";
import ReactModal from "react-modal";
import * as Ably from "ably";
import {
  AblyProvider,
  ChannelProvider,
  useChannel,
  useChannelStateListener,
  useConnectionStateListener,
} from "ably/react";
import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { IoMdVolumeOff, IoMdVolumeHigh } from "react-icons/io";
import { debounce, throttle } from "lodash";
import { trackEvent } from "../utils/mixpanel";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const VideoTab = (props) => {
  const reduxState = useSelector((state) => state);

  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState("");
  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(window.innerWidth);
  const [speed, setSpeed] = useState(1);
  const [matchDetails, setMatchDetails] = useState(null);
  const [duration, setDuration] = useState(null);
  const [seeking, setSeeking] = useState(false);
  const [jumpTo, setJumpTo] = useState("");
  const [playerIsFullscreen, setPlayerIsFullscreen] = useState(false);
  const [showControls, setShowControl] = useState(false);
  const [matchVideoData, setMatchVideoData] = useState(null);

  const [time, setTime] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const intervalRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ablyMessagesEvent, setAblyMessagesEvent] = useState("");
  const [analysisInfoDetails, setAnalysisInfoDetails] = useState();
  const [dialogBoxText, setDialogBoxText] = useState("");
  const [status, setStatus] = useState(0);
  const [isMute, setIsMute] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const showDeploymentBtn = location.state?.TechQCSubmit;

  //ably channel for webhook
  const { channel } = useChannel(
    "analyst_portal_" + props.analystId,
    // asdasd,
    (message) => {
      // Only process unnamed messages
      if (message.name === "" || message.name === "match_analysis_event") {
        try {
          const event = JSON.parse(message.data);

          if (event?.event) {
            handleIncomingEvent(event.event);
          }
        } catch (err) {
          console.error("Invalid JSON in message.data", message.data);
        }
      }
    }
  );

  // Debounced update to avoid flooding state
  const handleIncomingEvent = useCallback(
    debounce((eventData) => {
      setAblyMessagesEvent({
        message: eventData,
        isInitial: false,
      });
    }, 100), // You can adjust this to a slightly higher value like 200ms if needed
    []
  );

  useEffect(() => {
    if (
      isActive &&
      status !== 9 &&
      status !== 8 &&
      status !== 6 &&
      status !== 3
    ) {
      let counter = 0;

      const intervalId = setInterval(() => {
        setTime((prevTime) => {
          const newTime = prevTime + 1;
          counter += 1;

          // Call the API after every 30 seconds
          if (counter === 15) {
            updateTat(newTime); // Using the latest state value
            // localStorage.setItem("videoTabTat", JSON.stringify(newTime));
            localStorage.setItem(
              "videoTabTat",
              JSON.stringify({ [match_id]: newTime })
            );
            counter = 0;
          }

          return newTime;
        });
      }, 1000); // Update every second

      return () => clearInterval(intervalId);
    }
  }, [isActive, status]);
  
  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const {
    seekToTime,
    UpdateVideoTime,
    SetVideoControl,
    videoTime,
    videoControl,
  } = props;
  const query = useQuery();
  const match_id = query.get("match_id");

  const playerRef = useRef();

  const updateTat = useCallback(
    async (currTime) => {
      try {
        const res = await axios.post(
          `${MAIN_API}update_match_analysis_tat/`,
          {
            match_id: parseInt(match_id),
            analyst_id: parseInt(props.analystId),
            tat: parseInt(currTime),
          },
          {
            headers: {
              Authorization: `ANALYST ${reduxState?.auth?.token}`,
            },
          }
        );
        return res.response_data;
      } catch (err) {
        console.error(err);
      }
    },
    [match_id, props.analystId, reduxState.auth.token]
  );

  // useEffect(() => {
  //   if (isActive) {
  //     let counter = 0;

  //     const intervalId = setInterval(() => {
  //       setTime((prevTime) => {
  //         const newTime = prevTime + 1;
  //         counter += 1;

  //         // Call the API after every 30 seconds
  //         if (counter === 30) {
  //           updateTat(newTime); // Using the latest state value
  //           localStorage.setItem(
  //             "videoTabTat",
  //             JSON.stringify({ [match_id]: newTime })
  //           );
  //           counter = 0;
  //         }

  //         return newTime;
  //       });
  //     }, 1000); // Update every second

  //     return () => clearInterval(intervalId);
  //   }
  // }, [isActive, match_id, updateTat]);

  //api call to push tat when a trigger from mobile will come
  // eg: keyboard screen has been opened, close , analysis done , browser closed

  // analysis_event_status: "pause"
  // current_analysis_time: "2024-10-26T14:02:34.744000"
  // total_video_duration_in_sec: 5406
  const getAnalysisStatus = useCallback(async () => {
    try {
      const res = await axios.post(
        `${MAIN_API}get_matchwise_analysis_status/`,
        {
          match_id: parseInt(match_id),
          analyst_id: parseInt(props.analystId),
        },
        {
          headers: {
            Authorization: `ANALYST ${reduxState?.auth?.token}`,
          },
        }
      );
      setAnalysisInfoDetails(res.data.response_data);
      // setting initial event
      setAblyMessagesEvent({
        message: res.data.response_data.analysis_event_status,
        isInitial: true,
      });
      return res.response_data;
    } catch (err) {
      console.error(err);
    }
  }, [match_id, props.analystId, reduxState.auth.token]);

  useEffect(() => {
    getAnalysisStatus();
  }, [getAnalysisStatus]);

  useEffect(() => {
    trackEvent().track('entered_video_screen', { match_id: match_id });
  }, []);

  // Mixpanel – TAT started / stopped, driven by isActive so it only fires on real state changes
  const tatMountedRef = useRef(false);
  useEffect(() => {
    if (!tatMountedRef.current) {
      tatMountedRef.current = true;
      return;
    }
    if (isActive) {
      trackEvent().track('tat_started', { match_id: match_id });
    } else {
      trackEvent().track('tat_stopped', { match_id: match_id, elapsed_seconds: time });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  useEffect(() => {
    if (ablyMessagesEvent) {
      if (
        ablyMessagesEvent.message === "start" ||
        ablyMessagesEvent.message === "resume"
      ) {
        setIsActive(true);
      } else if (ablyMessagesEvent.message === "pause") {
        setIsActive(false);
      } else {
        setIsActive(false);
      }

      // dialog box logic
      if (
        ablyMessagesEvent.isInitial &&
        (ablyMessagesEvent.message === "start" ||
          ablyMessagesEvent.message === "resume")
      ) {
        setIsModalOpen(false);
      }

      if (
        ablyMessagesEvent.isInitial &&
        ablyMessagesEvent.message === "pause"
      ) {
        setIsModalOpen(true);
        setDialogBoxText("Open Analysis Keyboard to continue.");
      } else if (
        !ablyMessagesEvent.isInitial &&
        ablyMessagesEvent.message === "pause"
      ) {
        updateTat(time);
        localStorage.setItem(
          "videoTabTat",
          JSON.stringify({ [match_id]: time })
        );
        setIsModalOpen(true);
        setDialogBoxText(
          "Match Analysis is paused from your Mobile Device. Open Analysis Keyboard to continue."
        );
      } else if (
        ablyMessagesEvent.isInitial &&
        ablyMessagesEvent.message === null
      ) {
        setDialogBoxText("Open Analysis Keyboard to continue.");
      }
    }
  }, [ablyMessagesEvent, match_id, time, updateTat]);

  const latestVideoTimeRef = useRef(props.videoTime);

  // Keep ref in sync with latest video time
  useEffect(() => {
    latestVideoTimeRef.current = props.videoTime;
  }, [props.videoTime]);

  useEffect(() => {
    if (!props.videoControl) {
      // Send latest time immediately on pause
      const data = new FormData();
      data.append("match_id", match_id);
      data.append("analyst_id", props.analystId);
      data.append("video_timestamp", latestVideoTimeRef.current);

      axios.post(`${SSENSE_URL}push_match_video_data/v2/`, data);

      return; // Don't start interval if not playing
    }

    const interval = setInterval(() => {
      const data = new FormData();
      data.append("match_id", match_id);
      data.append("analyst_id", props.analystId);
      data.append("video_timestamp", latestVideoTimeRef.current);

      axios.post(`${SSENSE_URL}push_match_video_data/v2/`, data);
    }, 1000); // send every 1 second

    return () => clearInterval(interval);
  }, [props.videoControl, match_id, props.analystId]);

  // useEffect(() => {
  //   if (props.videoControl) {
  //     let data = new FormData();
  //     data.append("match_id", match_id);
  //     data.append("analyst_id", props.analystId);
  //     data.append("video_timestamp", props.videoTime);
  //     axios.post(`${SSENSE_URL}push_match_video_data/v2/`, data);
  //   }
  // }, [match_id, props.analystId, props.videoControl, props.videoTime]);

  useEffect(() => {
    let data = new FormData();
    data.append("match_id", match_id);
    data.append("analyst_id", props.analystId);
    data.append("video_timestamp", "");
    axios.post(`${SSENSE_URL}push_match_video_data/v2/`, data);
  }, [match_id, props.analystId]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (screenfull.isEnabled) {
    screenfull.on("change", () => {
      setPlayerIsFullscreen(screenfull.isFullscreen);
    });
  }

  const full = () => {
    if (screenfull.isEnabled) {
      screenfull.request(findDOMNode(playerRef.current));
    }
  };

  const handleMute = () => {
    setIsMute(!isMute);
  };

  const jumpManually = (str) => {
    const jumpInputList = str.split(":");
    if (jumpInputList.length < 3) {
      return;
    }
    const totalSecends =
      parseInt(jumpInputList[0]) * 60 * 60 +
      parseInt(jumpInputList[1]) * 60 +
      parseInt(jumpInputList[2]);
    playerRef.current.seekTo(parseFloat(totalSecends));
    setPlaying(true);
    setJumpTo("");
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Prevent the default behavior
      // localStorage.setItem("videoTabTat", JSON.stringify(time));
      event.preventDefault();
      event.returnValue = ""; // Required for modern browsers
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (match_id && props.all_matches) {
      const details = props.all_matches?.find((m) => {
        return m.id.toString() === match_id;
      });
      setStatus(details?.status);
      const video = details?.youtube_videos;
      const matchVideo = video?.find((item) => {
        return item?.matches?.[0].toString() === match_id.toString();
      });
      if (matchVideo) {
        matchVideo.url && setMatchVideoData(matchVideo);
        matchVideo.url && props.LoadVideoUrl(matchVideo.url);
      }
      if (details) {
        setMatchDetails(details);
        if (JSON.parse(localStorage.getItem("videoTabTat"))?.[match_id] > 0) {
          setTime(JSON.parse(localStorage.getItem("videoTabTat"))?.[match_id]);
        } else {
          setTime(details?.analyst_tat);
        }
      } else {
        setMatchDetails(null);
      }
    }
  }, [match_id, props.all_matches]);

  const handleSeekMouseDown = (e) => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    UpdateVideoTime(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    playerRef.current.seekTo(parseFloat(e.target.value));
  };

  useEffect(() => {
    if (seekToTime) {
      setSeeking(true);
      UpdateVideoTime(seekToTime);
      playerRef.current.seekTo(seekToTime);
      setSeeking(false);
    }
  }, [UpdateVideoTime, seekToTime]);

  const initialHandleUserKeyPress = useCallback(
    (event) => {
      const { key, keyCode } = event;

      if (keyCode === 32) {
        SetVideoControl(!videoControl);
      }
      if (keyCode === 39) {
        playerRef.current.seekTo(parseFloat(videoTime + 5));
      }
      if (keyCode === 37) {
        playerRef.current.seekTo(parseFloat(videoTime - 5));
      }
    },
    [SetVideoControl, videoControl, videoTime]
  );

  const getWidth = () => {
    setLayoutWidth(window.innerWidth);
  };

  const gotoSubmitHandler = () => {
    history.push(`/matchupdate/${match_id}`);
  };

  useEffect(() => {
    window.addEventListener("keydown", initialHandleUserKeyPress);
    window.addEventListener("keyup", () => ClearSeekFlag());
    window.addEventListener("resize", () => getWidth());
    return () => {
      window.removeEventListener("keydown", initialHandleUserKeyPress);
      window.removeEventListener("keyup", () => ClearSeekFlag());
      return () => window.removeEventListener("resize", () => getWidth());
    };
  }, [initialHandleUserKeyPress]);

  if (loading) {
    return (
      <View
        style={{
          width: "100%",
          height: "100%",
          zIndex: 10,
          backgroundColor: "#fff",
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo />
        <Text style={{ color: "#131313", fontFamily: "Source Sans 3" }}>
          loading setup...
        </Text>
      </View>
    );
  }

  const isYoutubeUrl = () => {
    if (props?.videoUrl) {
      const hostname = new URL(props.videoUrl).hostname;
      return hostname.includes("youtube.com");
    }
    return false;
  };

  return (
    <View>
      <View
        id="topLine"
        style={{
          flexDirection: "row",
          paddingHorizontal: "2rem",
          marginVertical: "1rem",
          alignItems: "center",
        }}
      >
        <IconButton
          onClick={() => {
            history.goBack();
          }}
          size="small"
          sx={{ background: "#e1e1e1", mr: 1 }}
        >
          <ArrowBack fontSize="16px" />
        </IconButton>
        <Text
          style={{
            marginRight: "0.5rem",
            fontSize: "1rem",
            fontFamily: "Source Sans 3",
            color: "rgba(9, 16, 29, 1)",
          }}
        >
          Analyse Match
        </Text>
        <FaChevronRight color="rgba(9, 16, 29, 1)" />
        <Text
          style={{
            marginStart: "0.5rem",
            fontSize: "1rem",
            fontFamily: "Source Sans 3",
            color: "rgba(9, 16, 29, 1)",
          }}
        >
          {match_id} {matchDetails?.team_a_details?.name} vs{" "}
          {matchDetails?.team_b_details?.name}
        </Text>
      </View>

      <ReactModal
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={true}
        // onRequestClose={() => setIsModalOpen(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(5px)",
          },
          content: {
            // boxShadow: "0px 2px 10px #e1e1e1",
            backgroundColor: "#fff",
            // height: "20vh",
            width: "30vw",
            border: "none",
            inset: "auto",
            display: "flex",
            padding: "0 0 0 0",
            borderRadius: "0.2rem",
          },
        }}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(255, 255, 255, 1)",
          }}
        >
          <View
            style={{
              backgroundColor: "rgba(255, 244, 236, 1)",
              paddingHorizontal: "1rem",
              paddingVertical: "0.5rem",
              borderBottomColor: "rgba(185, 80, 0, 1)",
              borderBottomWidth: 2,
            }}
          >
            <Text
              style={{
                color: "rgba(185, 80, 0, 1)",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              Analysis Paused
            </Text>
          </View>
          <View
            style={{
              paddingHorizontal: "1rem",
              borderBottomColor: "rgba(144, 152, 161, 1)",
              borderBottomWidth: 1,
              paddingVertical: "1rem",
            }}
          >
            <Text
              style={{
                color: "rgba(185, 80, 0, 1)",
                fontSize: "12px",
                fontWeight: 400,
              }}
            >
              {dialogBoxText}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              gap: "0.6rem",
              paddingVertical: "0.8rem",
              justifyContent: "flex-end",
              marginHorizontal: "1rem",
            }}
          >
            <TouchableOpacity
              onPress={getAnalysisStatus}
              style={{
                borderColor: "rgba(144, 152, 161, 1)",
                borderRadius: "0.2rem",
                borderWidth: 1,
                paddingHorizontal: "0.5rem",
                paddingVertical: "0.2rem",
              }}
            >
              <Text
                style={{
                  color: "rgba(144, 152, 161, 1)",
                  fontSize: "14",
                  fontWeight: "600",
                }}
              >
                Refresh
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => setIsModalOpen(false)}
              style={{
                borderRadius: "0.2rem",
                paddingHorizontal: "0.5rem",
                paddingVertical: "0.2rem",
                backgroundColor: "rgba(185, 80, 0, 1)",
              }}
            >
              <Text
                style={{
                  color: "rgba(255, 255, 255, 1)",
                  fontSize: "14",
                  fontWeight: "600",
                }}
              >
                Close
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </ReactModal>

      {/* new */}

      <View
        onLayout={(e) => {
          setLayoutWidth(e.nativeEvent.layout.width);
        }}
        style={styles.container}
      >
        <View style={styles.videoContainer}>
          {!ready && (
            <View style={styles.noUrlShowContainer}>
              <Text style={styles.semiBoldText}>Custom URL</Text>
              <InputField
                onChangeText={setUrl}
                value={url}
                customStyle={{
                  borderRadius: 25,
                  borderColor: "#fff",
                  marginLeft: 10,
                  marginRight: 10,
                }}
                textStyle={{ color: "#fff" }}
                placeholder="Paste Video Url"
              />
              <SimpleButton
                label="Load Video"
                onPress={() => {
                  props.LoadVideoUrl(url);
                }}
              />
              <FaTimesCircle
                onClick={() => setReady(true)}
                style={{
                  marginLeft: 10,
                  color: "#fff",
                  fontSize: layoutWidth / 50,
                }}
              />
            </View>
          )}

          <VideoPlayer
            cref={playerRef}
            url={props.videoUrl}
            controls={showControls}
            played={props.videoTime}
            muted={isMute}
            onProgress={(e) => {
              !seeking && UpdateVideoTime(e);
            }}
            //    setElapsedTime={this.setElapsedTime}
            playing={props.videoControl}
            onPause={() => {
              SetVideoControl(false);
            }}
            onEnded={() => {
              SetVideoControl(false);
            }}
            onPlay={() => {
              SetVideoControl(true);
            }}
            onReady={() => {
              setReady(true);
            }}
            playbackRate={speed}
            onDuration={(t) => {
              setDuration(t);
            }}
          />

          {ready && !isYoutubeUrl() && (
            <View style={styles.videoTimeline}>
              <input
                type="range"
                value={props.videoTime}
                style={{ width: "100%", borderWidth: 0 }}
                min={0}
                max={duration}
                onMouseDown={handleSeekMouseDown}
                onChange={handleSeekChange}
                onMouseUp={handleSeekMouseUp}
              />
              <TouchableOpacity
                onPress={full}
                style={{
                  width: 2 * (layoutWidth / 100),
                  height: 2 * (layoutWidth / 100),
                  borderRadius: 5,
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 2px 6px #00000020",
                  backgroundColor: "#e1e1e1",
                  marginRight: 10,
                  marginLeft: 3,
                }}
              >
                <AiOutlineFullscreen color="#131313" size={layoutWidth / 100} />
              </TouchableOpacity>
              <TouchableOpacity
                onPress={handleMute}
                style={{
                  width: 2 * (layoutWidth / 100),
                  height: 2 * (layoutWidth / 100),
                  borderRadius: 5,
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 2px 6px #00000020",
                  backgroundColor: "#e1e1e1",
                  marginRight: 10,
                  marginLeft: 3,
                }}
              >
                {isMute ? (
                  <IoMdVolumeOff color="#131313" size={layoutWidth / 100} />
                ) : (
                  <IoMdVolumeHigh color="#131313" size={layoutWidth / 100} />
                )}
              </TouchableOpacity>
            </View>
          )}
          {ready && (
            <View style={styles.controlContainer}>
              <View style={styles.leftControl}>
                <FaStopwatch size={"1rem"} color="rgba(170, 173, 177, 1)" />
                {/* <CiStopwatch /> */}
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "rgba(9, 16, 29, 1)",
                    marginStart: "0.5rem",
                  }}
                >
                  Jump To :
                </Text>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <TextInput
                    style={{
                      maxWidth: "5rem",
                      fontSize: "10px",
                      border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                      borderRadius: "3px",
                      color: "rgba(33, 33, 46, 0.50)",
                      paddingVertical: "0.8rem",
                      outline: "none",
                      textAlign: "center",
                      marginStart: "0.8rem",
                    }}
                    onChangeText={setJumpTo}
                    defaultValue={jumpTo}
                    placeholder="HH:MM:SS"
                  />
                  <TouchableOpacity
                    disabled={jumpTo === ""}
                    onPress={() => jumpManually(jumpTo)}
                    style={{
                      width: "1.4rem",
                      height: "1.4rem",
                      marginStart: "0.5rem",
                      borderRadius: 5,
                      justifyContent: "center",
                      alignItems: "center",
                      borderColor: "#111",
                      borderWidth: 1,
                    }}
                  >
                    <FaArrowRight size={10} />
                  </TouchableOpacity>
                </View>
              </View>
              {!isYoutubeUrl() ? (
                <>
                  <View style={styles.middleControl}>
                    <Duration seconds={props.videoTime} />

                    <TouchableOpacity
                      onPress={() => {
                        props.SetVideoControl(!props.videoControl);
                      }}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: "rgba(232, 108, 0, 1)",
                        paddingHorizontal: "4rem",
                        paddingVertical: "1rem",
                        borderRadius: "8px",
                      }}
                    >
                      <View
                        style={{
                          width: "1rem",
                          height: "1rem",
                          borderRadius: "2rem",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "#fff",
                        }}
                      >
                        {!props.videoControl ? (
                          <FaPlay
                            color="rgba(232, 108, 0, 1)"
                            size={"0.5rem"}
                          />
                        ) : (
                          <FaPause
                            color="rgba(232, 108, 0, 1)"
                            size={"0.5rem"}
                          />
                        )}
                      </View>

                      <Text
                        style={{
                          fontsize: "18px",
                          color: "#fff",
                          fontWeight: "600",
                          marginStart: "0.6rem",
                        }}
                      >
                        {!props.videoControl ? "Play Video" : "Pause Video"}
                      </Text>
                    </TouchableOpacity>
                  </View>

                  <View style={styles.rightControl}>
                    <Text
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "10px",
                        fontWeight: "600",
                        color: "rgba(33, 33, 46, 0.5)",
                      }}
                    >
                      Playback Speed:
                    </Text>
                    <View
                      style={{
                        marginStart: "1rem",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <TouchableOpacity
                        onPress={() => {
                          setSpeed(0.25);
                        }}
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          margin: 5,
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          backgroundColor:
                            speed === 0.25 && "rgba(232, 108, 0, 1)",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color:
                              speed === 0.25
                                ? "#fff"
                                : "rgba(33, 33, 46, 0.50)",
                          }}
                        >
                          0.25x
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setSpeed(0.5);
                        }}
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          margin: 5,
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          backgroundColor:
                            speed === 0.5 && "rgba(232, 108, 0, 1)",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color:
                              speed === 0.5 ? "#fff" : "rgba(33, 33, 46, 0.50)",
                          }}
                        >
                          0.5x
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setSpeed(0.75);
                        }}
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          margin: 5,
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          backgroundColor:
                            speed === 0.75 && "rgba(232, 108, 0, 1)",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color:
                              speed === 0.75
                                ? "#fff"
                                : "rgba(33, 33, 46, 0.50)",
                          }}
                        >
                          0.75x
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setSpeed(1);
                        }}
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          margin: 5,
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          backgroundColor:
                            speed === 1 && "rgba(232, 108, 0, 1)",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color:
                              speed === 1 ? "#fff" : "rgba(33, 33, 46, 0.50)",
                          }}
                        >
                          1x
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setSpeed(1.25);
                        }}
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          margin: 5,
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          backgroundColor:
                            speed === 1.25 && "rgba(232, 108, 0, 1)",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color:
                              speed === 1.25
                                ? "#fff"
                                : "rgba(33, 33, 46, 0.50)",
                          }}
                        >
                          1.25x
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setSpeed(1.5);
                        }}
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          margin: 5,
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          backgroundColor:
                            speed === 1.5 && "rgba(232, 108, 0, 1)",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color:
                              speed === 1.5 ? "#fff" : "rgba(33, 33, 46, 0.50)",
                          }}
                        >
                          1.5x
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setSpeed(1.75);
                        }}
                        style={{
                          width: "2.5rem",
                          height: "2.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          margin: 5,
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          backgroundColor:
                            speed === 1.75 && "rgba(232, 108, 0, 1)",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color:
                              speed === 1.75
                                ? "#fff"
                                : "rgba(33, 33, 46, 0.50)",
                          }}
                        >
                          1.75x
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </>
              ) : null}
            </View>
          )}
          <View
            style={{
              width: "96%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "rgba(238, 242, 250, 1)",
              alignSelf: "center",
              paddingHorizontal: "0.8rem",
              paddingVertical: "1rem",
              marginVertical: "1rem",
            }}
          >
            <View style={{ flexDirection: "row" }}>
              <Text
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "rgba(51, 51, 51, 1)",
                }}
              >
                Match Url :{" "}
              </Text>
              <Text
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "rgba(51, 51, 51, 1)",
                }}
              >
                {props.videoUrl}
              </Text>
            </View>
            <TouchableOpacity
              onPress={() => {
                ready && setReady(false);
              }}
            >
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "rgba(51, 51, 51, 1)",
                }}
              >
                Load Custom URL
              </Text>
            </TouchableOpacity>
          </View>
        </View>

        <View style={styles.infoContainer}>
          <View
            style={{ position: "fixed", bottom: 15, right: 15, opacity: 0.3 }}
          >
            <Logo />
          </View>

          <View
            style={{
              padding: "1em",
              borderRadius: "0.2em",
              boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
            }}
          >
            <Text
              style={{
                fontFamily: "Source Sans 3",
                fontWeight: "600",
                fontSize: "1em",
              }}
            >
              Match Details
            </Text>

            <Text
              style={{
                marginTop: "1em",
                fontFamily: "Source Sans 3",
                fontWeight: "600",
                fontSize: "1em",
                color: "#667085",
              }}
            >
              {match_id} {matchDetails?.team_a_details?.name} vs{" "}
              {matchDetails?.team_b_details?.name}
            </Text>

            <Text
              style={{
                marginTop: "0.4em",
                fontFamily: "Source Sans 3",
                fontWeight: "400",
                fontSize: "0.6em",
                color: "#667085",
              }}
            >
              {matchDetails?.tournament_name}
              {" Tournament Name"}
            </Text>

            <View
              style={{
                marginTop: "1em",
                flexDirection: "row",
                backgroundColor: "rgba(238, 242, 250, 1)",
                padding: "1em",
                borderRadius: "0.2em",
                justifyContent: "space-between",
              }}
            >
              <Text
                style={{
                  fontFamily: "Source Sans 3",
                  fontWeight: 400,
                  color: "rgba(9, 16, 29, 1)",
                }}
              >
                Analyst Details
              </Text>
              <Text
                style={{
                  fontFamily: "Source Sans 3",
                  fontWeight: 400,
                  color: "rgba(9, 16, 29, 1)",
                }}
              >
                {matchDetails?.analyst_details[0]?.id}
              </Text>
              <Text
                style={{
                  fontFamily: "Source Sans 3",
                  fontWeight: 600,
                  color: "rgba(9, 16, 29, 1)",
                }}
              >
                {matchDetails?.analyst_details[0]?.name}
              </Text>
            </View>

            <View
              style={{
                marginTop: "1em",
                flexDirection: "row",
                backgroundColor: "rgba(238, 242, 250, 1)",
                padding: "1em",
                borderRadius: "0.2em",
                justifyContent: "space-between",
              }}
            >
              <Text
                style={{
                  fontFamily: "Source Sans 3",
                  fontWeight: 400,
                  color: "rgba(9, 16, 29, 1)",
                }}
              >
                Game Time
              </Text>
              <Text
                style={{
                  fontFamily: "Source Sans 3",
                  fontWeight: 400,
                  color: "rgba(9, 16, 29, 1)",
                }}
              >
                {(matchDetails &&
                  matchDetails.game_time &&
                  matchDetails.game_time + " minutes") ||
                  "NA"}
              </Text>
            </View>
          </View>
          <View
            style={{
              padding: "1em",
              backgroundColor: "rgba(238, 242, 250, 0.2)",
              marginTop: "1em",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  flex: 1,
                  paddingVertical: "0.5em",
                  marginHorizontal: "1em",
                  fontFamily: "Source Sans 3",
                  color: "rgba(0, 0, 0, 1)",
                  backgroundColor: "rgba(231, 245, 236, 1)",
                  fontWeight: "400",
                  fontSize: "0.8em",
                  textAlign: "center",
                }}
              >
                Team A
              </Text>
              <Text
                style={{
                  flex: 1,
                  paddingVertical: "0.5em",
                  marginHorizontal: "1em",
                  fontFamily: "Source Sans 3",
                  color: "rgba(0, 0, 0, 1)",
                  backgroundColor: "rgba(229, 245, 252, 1)",
                  fontWeight: "400",
                  fontSize: "0.8em",
                  textAlign: "center",
                }}
              >
                Team B
              </Text>
            </View>
            <View
              style={{
                marginTop: "0.5em",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  flex: 1,
                  fontFamily: "Source Sans 3",
                  fontWeight: "600",
                  fontSize: "1em",
                  textAlign: "center",
                  paddingHorizontal: "0.5em",
                  maxWidth: "10em",
                }}
              >
                {matchDetails &&
                  matchDetails?.team_a_details &&
                  matchDetails?.team_a_details?.name}
              </Text>
              <Text
                style={{
                  flex: 1,
                  fontFamily: "Source Sans 3",
                  fontWeight: "600",
                  fontSize: "1em",
                  textAlign: "center",
                  paddingHorizontal: "0.5em",
                  maxWidth: "10em",
                }}
              >
                {matchDetails &&
                  matchDetails.team_b_details &&
                  matchDetails.team_b_details.name}
              </Text>
            </View>

            {/* <View
                style={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 20,
                  paddingHorizontal: 10,
                }}
              >
                <Text
                  style={{
                    color: "#131313",
                    fontSize: layoutWidth / 160,
                    opacity: 0.7,
                    fontFamily: "Poppins",
                    fontWeight: "700",
                    paddingBottom: 2,
                  }}
                >
                  Match Video URL :
                </Text>
                <TextInput
                  selectTextOnFocus
                  value={props.videoUrl}
                  numberOfLines={1}
                  selection={{ start: 0, end: -1 }}
                  style={{
                    outline: "none",
                    width: "100%",
                    fontSize: layoutWidth / 130,
                    color: "#131313",
                    backgroundColor: "#e1e1e1",
                  }}
                />
              </View>
              <View
                style={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 10,
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    ready && setReady(false);
                  }}
                >
                  <Text
                    style={{
                      color: "#F28C33",
                      fontSize: layoutWidth / 130,
                      opacity: 1,
                      textDecorationLine: "underline",
                      marginBottom: 20,
                    }}
                  >
                    Load Custom URL
                  </Text>
                </TouchableOpacity>
              </View> */}
          </View>
          <View
            style={{
              marginTop: "2rem",
              padding: "1rem",
              borderRadius: "0.2em",
              boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
              flexDirection: "row",
            }}
          >
            <View
              style={{
                // paddingVertical: "1rem",
                justifyContent: "center",
                paddingHorizontal: "1rem",
                fontFamily: "Source Sans 3",
                color: "rgba(0, 0, 0, 1)",
                backgroundColor: "rgba(231, 245, 236, 1)",
                textAlign: "center",
              }}
            >
              <Text
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "rgba(9, 16, 29, 1)",
                }}
              >
                {formatTimeFromSeconds(time)}
                {/* 00:00:00 */}
              </Text>
            </View>
            <View
              style={{
                flexDirection: "column",
                marginStart: "1rem",
                gap: 10,
              }}
            >
              <Text
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "rgba(9, 16, 29, 1)",
                }}
              >
                Elapsed Time
              </Text>
              <Text
                style={{
                  fontSize: "10px",
                  fontWeight: "400",
                  color: "rgba(57, 68, 82, 1)",
                }}
              >
                Time take till now for analysis (min)
              </Text>
            </View>
          </View>
          <button
            onClick={() => history.push(`/techQC/${match_id}`)}
            style={{
              marginTop: "1rem",
              backgroundColor: "#FF5A1F",
              border: "none",
              borderRadius: 8,
              padding: "12px 24px",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            <FaBug style={{ marginRight: 8 }} />
            <span style={{ marginRight: 8 }}>Next Step</span>
            <FaArrowRight />
          </button>
          {showDeploymentBtn && (
            <button
              onClick={() => {
                gotoSubmitHandler();
              }}
              style={{
                marginTop: "1rem",
                backgroundColor: "rgba(0, 146, 54, 1)",
                border: "none",
                borderRadius: 8,
                padding: "12px 24px",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  color: "rgba(255, 255, 255, 1)",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                Proceed to Deployment
              </span>
              <FaArrowRight color={"#fff"} style={{ marginLeft: "0.5rem" }} />
            </button>
          )}
        </View>
      </View>
    </View>
  );
};

const mapStateToProps = (state) => {
  return {
    videoControl: state.control.videoControl,
    videoUrl: state.control.videoUrl,
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    currentAction: state.control.currentAction,
    analysedString: state.control.analysedString,
    actionLog: state.control.actionLog,
    seekToTime: state.control.seekToTime,
    analystId: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {
  UpdateVideoTime,
  LoadVideoUrl,
  SetVideoControl,
  SaveMatchString,
  SetControllerToggle,
  ClearSeekFlag,
})(VideoTab);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "#fff",
    marginBottom: "1rem",
  },
  videoContainer: {
    // width: "70%",
    // height: "80%",
    flex: "0.70",
    paddingHorizontal: "1rem",
    borderRadius: "0.2em",
    boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
    marginStart: "1.5rem",
  },
  noUrlShowContainer: {
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: 2,
    flexDirection: "row",
    backgroundColor: "#131313dd",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
  },
  semiBoldText: {
    fontFamily: "Poppins",
    fontSize: "1em",
    color: "#fff",
    fontWeight: "700",
  },
  videoTimeline: {
    paddingTop: 5,
    paddingBottom: 5,
    width: "100%",
    paddingHorizontal: "1rem",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItem: "center",
  },
  infoContainer: {
    flex: "0.29",
    justifyContent: "center",
    marginEnd: "1.5em",
    width: "25%",
    // backgroundColor: "red",
    height: "100%",
  },
  controlContainer: {
    width: "96%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "rgba(238, 242, 250, 1)",
    alignSelf: "center",
    paddingHorizontal: "0.8rem",
    paddingVertical: "1rem",
  },
  leftControl: {
    // flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    // backgroundColor: "red",
  },
  middleControl: {
    // flex: 1,
    alignItems: "center",
    // backgroundColor: "red",
  },
  rightControl: {
    flexDirection: "row",
    alignItems: "center",
    // backgroundColor: "red",
  },
});
